import { dismissToast, showError, showLoading, showSuccess } from "./Toast";
import { setBuyerSession } from "./authStorage";
import {
  clearAuthReturnTo,
  getAuthReturnTo,
} from "./authModal";
import { getGuestCart, mergeGuestCartIntoUserCart } from "./guestCart";

const getFailureSummary = (failedItems = []) => {
  if (!failedItems.length) return "";

  const firstFailure = failedItems[0]?.message;
  if (failedItems.length === 1 && firstFailure) {
    return `Some cart items could not be added after login: ${firstFailure}`;
  }

  return "Some cart items could not be added after login because availability changed.";
};

export const completeBuyerAuthentication = async (
  payload,
  { successMessage = "Login successful", onBeforeRedirect } = {},
) => {
  if (!payload?.token) {
    return null;
  }

  setBuyerSession(payload);

  const shouldMergeGuestCart = getGuestCart().length > 0;
  let loadingToastId = null;
  let mergeResult = {
    mergedItems: [],
    failedItems: [],
    serverCart: null,
  };

  if (shouldMergeGuestCart) {
    loadingToastId = showLoading("Preparing your cart...");
    try {
      mergeResult = await mergeGuestCartIntoUserCart();
    } catch {
      mergeResult = {
        ...mergeResult,
        failedItems: [{ message: "Cart restoration failed." }],
      };
    } finally {
      dismissToast(loadingToastId);
    }
  }

  const failureMessage = getFailureSummary(mergeResult.failedItems);
  if (failureMessage) {
    showError(failureMessage);
  } else if (mergeResult.refreshError) {
    showError("You are signed in, but we could not refresh all cart items. Please try again.");
  }

  showSuccess(successMessage);

  const destination = getAuthReturnTo() || "/";
  clearAuthReturnTo();
  onBeforeRedirect?.();

  if (typeof window !== "undefined") {
    window.location.href = destination;
  }

  return mergeResult;
};

